var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLuna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#172852",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD83D",
    d: "M9.666 5.363c1.405-.526 2.987-.527 4.418-.095 1.864.578 3.437 1.985 4.26 3.75.226.503.443 1.027.465 1.586-1.048-.607-2.196-1-3.347-1.36-1.84-.663-3.768-1.124-5.51-2.036-.406-.242-.923-.49-1.034-.996-.044-.436.418-.68.748-.85ZM5.424 9.61c.407-1.103 1.074-2.128 1.98-2.888.23 1.895 1.037 3.726 2.369 5.104 1.597 1.66 3.872 2.678 6.187 2.64.92.029 1.818-.184 2.714-.355-.881 3.187-4.375 5.303-7.611 4.794-1.954-.25-3.757-1.407-4.846-3.04-1.227-1.805-1.537-4.201-.793-6.254Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6F03",
    d: "M15.462 9.245c1.15.359 2.3.752 3.347 1.36l.07.037c.098.73.168 1.476.039 2.208-.527-.224-.954-.616-1.4-.963-.86-.715-1.737-1.533-2.056-2.642Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuna);
export default __webpack_public_path__ + "static/media/luna.61aab024ede13867d4e89fb7f830235d.svg";
export { ForwardRef as ReactComponent };